// extracted by mini-css-extract-plugin
module.exports = {"box":"styles_box__3bpbO","isCurrent":"styles_isCurrent__1bvz8","linkResort":"styles_linkResort__nuXXp","title":"styles_title__2N0MH","subtitle":"styles_subtitle__3UpQQ"};